
import { PlazasResumenProps } from "../../types/plaza";

export const PlazasResumen = ({ plazas }: PlazasResumenProps) => {
    return (
        <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <h2 className="text-lg font-semibold mb-2">Plazas Seleccionadas</h2>
            <div className="grid gap-2">
                {plazas.map((plaza, index) => (
                    <div key={index} className="bg-white p-3 rounded border">
                        <p className="font-medium">{plaza.dia} - {plaza.horaInicio}</p>
                        <p className="text-sm text-gray-600">Nivel: {plaza.nivel_nombre}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};